'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var luhnCheck = (function (arr) {
    return function (ccNum) {
        var len = ccNum.length;
        var bit = 1;
        var sum = 0;
        var val;

        while (len) {
            val = parseInt(ccNum.charAt(--len), 10);
            sum += (bit ^= 1) ? arr[val] : val;
        }

        return sum && sum % 10 === 0;
    };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]));

var cvvCheck = function (cvv) {
    return (/^[0-9]{3,4}$/).test(cvv);
};

var initCardExpiry = function () {
    $('.billing-continue-container .continue').click(function (e) {
        var radioVal = $('.payment-method-options').find(':checked').val();
        if ('CREDIT_CARD' == radioVal) {
            validateCardExpiry(this, true, false);
        }
    });
    $('.month-field .ui-selectmenu-button, .year-field .ui-selectmenu-button, .card-expiry.month, .card-expiry.year').bind('focus', function (e) {
        e.stopPropagation();
        $(this).on('blur', function() {
            validateCardExpiry(this, false,($('.payment-method-options').find(':checked').val() == 'CREDIT_CARD'));
        });
    });
};

var validateCardExpiry = function (el, checkEmpty, flagOnBlur) {
    // need to declare specifically in order not to confuse with other forms with similar inputs
    var $this = $(el);
    var $month = $this.closest('form').find('.card-expiry.month');
    var $year = $this.closest('form').find('.card-expiry.year');
    var hasError = false;

    var now = new Date();
    var nowMonth = now.getMonth() + 1;
    var nowYear = now.getFullYear();

    if (flagOnBlur && $this.siblings('select').val() == '') {
        var customyearRow = $this.parents().siblings('label');
        customyearRow.next('.error-placement').remove();
        $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">' + Resources.INVALID_CARDEXPIRY + '</span></div>').insertAfter(customyearRow);
        customyearRow.parent().find('span.ui-selectmenu-button, select').addClass('dropdownerror');
        hasError = true;
    } else {
        $this.removeClass('dropdownerror');
        $this.parent().find('span.ui-selectmenu-button').removeClass('dropdownerror');
        $this.parents().siblings('.error-placement').remove();
    }
    // validate only on form submit
    if (checkEmpty && (!$month.val() || !$year.val())) {
        var customyearRow = $('.month-field label,.year-field label');
        customyearRow.next('.error-placement').remove();
        $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">' + Resources.INVALID_CARDEXPIRY + '</span></div>').insertAfter(customyearRow);
        customyearRow.parent().find('span.ui-selectmenu-button, select').addClass('dropdownerror');
        hasError = true;

        // validate only if month and year has value, otherwise, ignore
    } else if ($month.val() && $year.val() && (($month.val() < nowMonth && $year.val() <= nowYear) || ($month.val() > nowMonth && $year.val() < nowYear))) {
        var customyearRow = $('.month-field label');
        customyearRow.next('.error-placement').remove();
        $('<div class="error-placement"><i class="error-icon error-icon-dropdown"></i><span class="error">' + Resources.INVALID_CARDEXPIRY + '</span></div>').insertAfter(customyearRow);
        $('.expiration-date span.ui-selectmenu-button, .expiration-date select').addClass('dropdownerror');
        hasError = true;
    }

    // highlight inputs if expiry has error 
    if (hasError) {
        if ($('.billing-address-section').length > 0) {
            $('.billing-address-section .continue').attr('disabled', 'true');
        }
    } else {
        hasError = false;
        $month.next().removeClass('dropdownerror');
        $year.next().removeClass('dropdownerror');
        $month.parents().siblings('.error-placement').remove();
        $year.parents().siblings('.error-placement').remove();
        if ($('.billing-address-section').length > 0) { //for page form guest user and unsaved card registered
            $('.billing-address-section .continue').removeAttr('disabled');
        }
    }
};

export default {
    init: function () {
        initCardExpiry();
    }
}
